import { faArrowLeft, faDownload } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import CustomButton from "components/CustomButton";
import Loader from "components/Loader";
import React from "react";
import { useState } from "react";
import { useEffect } from "react";
import Modal from "react-responsive-modal";
import SurveyService from "services/SurveyService";
import { ReactComponent as CloseIcon } from "assets/img/icons/cancel.svg";
import fileDownload from "js-file-download";
import { useToasts } from "react-toast-notifications";

const styles = {
  responseDiv: {
    borderBottom: "1px solid #e9e9e9",
    padding: "10px",
    display: "flex",
    gap: "1rem",
    alignItems: "center",
    justifyContent: "space-between",
  },
  count: {
    fontSize: "20px",
    fontWeight: "bold",
    color: "#ffa600",
  },
};

export default ({ onClose, surveyId, teamId }) => {
  const classes = styles;
  const { addToast } = useToasts();
  const [surveyData, setSurveyData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [type, setType] = useState("list");
  const [answers, setAnswers] = useState([]);
  const [downloading, setDownloading] = useState(false);

  const handleDownload = async () => {
    if (downloading) return;
    
    setDownloading(true);
    try {
      const response = await SurveyService.exportSurvey(surveyId, teamId);
      
      // Get filename from Content-Disposition header or use default
      const contentDisposition = response.headers["content-disposition"];
      let filename = `survey_${surveyId}_responses.csv`;
      
      if (contentDisposition) {
        const filenameMatch = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
        if (filenameMatch && filenameMatch[1]) {
          filename = filenameMatch[1].replace(/['"]/g, "");
        }
      }
      
      fileDownload(response.data, filename);
      addToast("Survey responses downloaded successfully.", {
        appearance: "success",
      });
    } catch (error) {
      console.error("Error downloading survey responses:", error);
      addToast("Failed to download survey responses. Please try again.", {
        appearance: "error",
      });
    } finally {
      setDownloading(false);
    }
  };

  useEffect(() => {
    setLoading(true);
    SurveyService.getSurveyResponses(surveyId, teamId).then((res) => {
      setSurveyData(res.data.data);
      setLoading(false);
    });
  }, [surveyId, teamId]);

  const swtichView = () => {
    setType(type === "list" ? "view" : "list");
  };
  const viewAnswers = (ans) => {
    setAnswers(ans);
    swtichView();
  };

  return (
    <Modal
      center
      closeOnEsc={false}
      closeOnOverlayClick={false}
      classNames={{
        modalContainer: "modalContainer",
        modal: "createTaskModal",
      }}
      showCloseIcon={false}
      open
      onClose={onClose}
    >
      <div className="modal fade popup-modal withcross create-task-popup">
        <h5 className="text-center createTaskHeading">Survey Responses</h5>
        <CustomButton type="button" buttonClass="btnClose">
          <CloseIcon style={{ width: "20px" }} onClick={onClose} />
        </CustomButton>
        <div className="mt-4 customScrollArea surveyResponseContianer">
          {loading && (
            <div className="d-flex justify-content-center">
              <Loader />
            </div>
          )}
          {surveyData.length > 0 &&
            !loading &&
            type === "list" &&
            surveyData.map((resp, index) => (
              <div key={resp.id || index} style={classes.responseDiv}>
                <div className="d-flex justify-content-between">
                  {resp.question}
                  <span className="badge badge-primary badge-pill text-warning">
                    {resp.type}
                  </span>
                </div>
                {/* <h6>
                  {resp.question}
                  <span class="badge badge-primary badge-pill text-primary">
                    {resp.type}
                  </span>
                </h6> */}
                <div className="d-flex justify-content-between align-items-center">
                  <div>
                    <span style={classes.count}>
                      {resp.total_response}/{resp.total_user}
                    </span>
                  </div>
                  <div>
                    <button
                      className="btn btn-light"
                      onClick={() => viewAnswers(resp)}
                    >
                      View
                    </button>
                  </div>
                </div>
              </div>
            ))}
          {type === "view" && (
            <div>
              <div className="d-flex align-items-basline">
                <FontAwesomeIcon
                  icon={faArrowLeft}
                  onClick={swtichView}
                  style={{ cursor: "pointer", fontSize: "1rem" }}
                />
                <p style={{ marginLeft: "1rem", fontSize: "1rem" }}>
                  {answers.question}
                </p>
              </div>
              <div>
                {answers.type === "range" && (
                  <div>
                    <table className="table">
                      <thead>
                        <tr>
                          <th scope="col">Answer</th>
                          <th scope="col">Member count</th>
                        </tr>
                      </thead>
                      <tbody>
                        {answers.answer.map((ans, index) => (
                          <tr key={index}>
                            <td>{ans.answer}</td>
                            <td>{ans.count}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}
                {answers.type === "text" && (
                  <div>
                    <table className="table">
                      <thead>
                        <tr>
                          <th scope="col">Answers</th>
                        </tr>
                      </thead>
                      <tbody>
                        {answers.answer.map((ans, index) => (
                          <tr key={index}>
                            <td>{ans.answer}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}
                {answers.type === "fixed" && (
                  <div>
                    <table className="table">
                      <thead>
                        <tr>
                          <th scope="col">Answer</th>
                          <th scope="col">Member count</th>
                        </tr>
                      </thead>
                      <tbody>
                        {answers.answer.map((ans, index) => (
                          <tr key={index}>
                            <td>{ans.selected_option?.option || "N/A"}</td>
                            <td>{ans.count}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
            </div>
          )}
        </div>

        <div className="mt-4 d-flex justify-content-between align-items-center">
          <CustomButton
            type="button"
            buttonClass="small-btn"
            onClick={handleDownload}
            disabled={downloading || loading}
            buttonStyle={{ display: "flex", alignItems: "center", gap: "0.5rem" }}
          >
            <FontAwesomeIcon icon={faDownload} />
            {downloading ? "Downloading..." : "Download Responses"}
          </CustomButton>
          <CustomButton
            type="button"
            buttonClass="small-btn me-2"
            name="Close"
            onClick={onClose}
          />
        </div>
      </div>
    </Modal>
  );
};
